import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EMPTY_VALUE_DASH } from '../../constants/app';
import useMoney from '../../hooks/useMoney/useMoney';
import styles from './NextPayment.less';
export function NextPayment({ days, amount }) {
    const { formatMoney } = useMoney();
    return (_jsxs("div", { className: "d-flex flex-align-center flex-justify-space-between", children: [!amount && !days && _jsx("span", { children: EMPTY_VALUE_DASH }), !!amount && _jsx("span", { className: styles.nextPaymentAmount, children: formatMoney(amount) }), !!days && _jsxs("span", { children: ["in ", days, " d"] })] }));
}
